<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    historyState, insertHistoryAction, resetHistory
} from '@app/store/historyStore.svelte.js';
import { createEventDispatcher } from 'svelte';
import * as m from "@app/paraglide/messages.js";
const dispatch = createEventDispatcher();

function markEvents() {
    try {
        eventGroupState[projectState.selected].selected.forEach(selectedEventIndex => {
            eventGroupState[projectState.selected].events[selectedEventIndex].forced = true;
        });

        insertHistoryAction({
            name: "forced events", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    } catch(err){
        console.log(err);
        console.log(err.message);
    } finally {
        dispatch("done");
    }
}
</script>

<a id="btnForcedSubtitle"
    class="dropdown-item"
   role="menuitem"
    aria-label={m.context_menu_forced_subtitle_label()}
   href="#!/"
   onclick={markEvents}>
    {m.context_menu_forced_subtitle()}
</a>
